import { LOCATION_HUB_LIST, MAIN_NAV_ITEMS } from "@/utils/newsroomCollections";

export const STATIC_PAGE_CONTENT = {
  about: {
    route: "/about",
    title: "About Content Watch HQ",
    overline: "About the newsroom",
    description: "Content Watch HQ is a Houston-first independent digital newsroom focused on breaking news, public safety, investigations, public records, and accountability journalism across Southeast Texas.",
    intro: "Your headquarters for news now.",
    sections: [
      {
        heading: "Mission",
        body: "Deliver fast, factual, community-focused reporting through investigative journalism, public records research, emergency coverage, and accountability reporting.",
      },
      {
        heading: "Coverage priorities",
        body: "We focus on Houston breaking news, crime, public safety, politics, public records, weather, traffic, investigations, and community impact stories.",
      },
      {
        heading: "Parent company",
        body: "Federal News Network Inc. supports Content Watch HQ operations while the public-facing newsroom remains Content Watch HQ through 2026.",
      },
    ],
  },
  "editorial-standards": {
    route: "/editorial-standards",
    title: "Editorial Standards",
    overline: "Trust and standards",
    description: "How Content Watch HQ approaches verification, transparency, corrections, and community-centered reporting.",
    intro: "Our newsroom standards are built around speed without sacrificing accuracy.",
    sections: [
      { heading: "Verification", body: "We seek official confirmation, on-scene observation, documents, and direct-source reporting before presenting claims as fact." },
      { heading: "Transparency", body: "When information is preliminary, developing, or unconfirmed, we label it clearly and update stories as facts change." },
      { heading: "Original reporting", body: "We prioritize firsthand reporting, public records, interviews, and clear sourcing over rewrites and unsupported aggregation." },
    ],
  },
  corrections: {
    route: "/corrections-policy",
    title: "Corrections Policy",
    overline: "Corrections",
    description: "Content Watch HQ corrections and update standards for public-facing stories and live coverage.",
    intro: "When we get something wrong, we fix it quickly and clearly.",
    sections: [
      { heading: "How we correct", body: "Material errors are corrected in the article, and significant changes should be reflected in the story’s updated timestamp." },
      { heading: "Reader feedback", body: "Readers can report possible inaccuracies through our contact and tip channels so the newsroom can review the concern promptly." },
      { heading: "Clarifications", body: "When the language of a story needs precision but the core facts remain correct, we may issue a clarification rather than a correction." },
    ],
  },
  privacy: {
    route: "/privacy-policy",
    title: "Privacy Policy",
    overline: "Privacy",
    description: "How Content Watch HQ handles submission data, newsroom communications, analytics, and public interactions.",
    intro: "We collect only the information needed to respond to readers, process submissions, and improve the newsroom experience.",
    sections: [
      { heading: "Submission data", body: "Contact, newsletter, and tip forms store the information you provide so newsroom staff can review and respond inside the admin dashboard." },
      { heading: "Analytics", body: "Basic site and sponsor interaction analytics may be used to understand newsroom performance and improve the user experience." },
      { heading: "Contact permissions", body: "If you tell us not to contact you, the newsroom should respect that preference unless legally required otherwise." },
    ],
  },
  terms: {
    route: "/terms-of-use",
    title: "Terms of Use",
    overline: "Terms",
    description: "General terms covering access to Content Watch HQ content, submissions, and newsroom services.",
    intro: "By using the site, you agree not to misuse newsroom tools, impersonate others, or submit unlawful material.",
    sections: [
      { heading: "Use of content", body: "Content Watch HQ reporting, images, and branding remain protected. Republishing or scraping should require permission unless otherwise stated." },
      { heading: "Submissions", body: "By sending tips, contact requests, or newsletter details, you confirm you have the right to share the information you submit." },
      { heading: "Availability", body: "We may change newsroom features, sections, and workflows as the platform evolves." },
    ],
  },
};

export const AUTHOR_PROFILE_DEFAULTS = {
  bio: "covers breaking news, accountability reporting, and Houston-first updates for Content Watch HQ.",
  email: "info@contentwatchhq.com",
};

export const getAuthorSlug = (author = "content-watch-staff") => author.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "content-watch-staff";

export const buildAuthorProfile = (author, stories) => {
  const authorStories = (stories || []).filter((story) => story.author === author);
  const primaryStory = authorStories[0];
  return {
    slug: getAuthorSlug(author),
    name: author,
    role: "Reporter",
    bio: `${author} ${AUTHOR_PROFILE_DEFAULTS.bio}`,
    email: AUTHOR_PROFILE_DEFAULTS.email,
    location: primaryStory?.location || "Houston, Texas",
    socialLinks: [
      { label: "Instagram", url: "https://www.instagram.com/contentwatchhq/" },
      { label: "YouTube", url: "https://www.youtube.com/@CONTENTWATCHhq" },
      { label: "Facebook", url: "https://www.facebook.com/contentwatchhq/" },
    ],
    stories: authorStories,
  };
};

export const SEARCHABLE_LINKS = [
  ...MAIN_NAV_ITEMS,
  ...LOCATION_HUB_LIST.map((hub) => ({ label: hub.title, to: hub.route })),
];